import React, {useEffect, useState, useContext} from 'react'
import axios from 'axios'
import { GlobalState } from '../../GlobalState';
import bg from '../../img/bg.png'

export default function MainPage() {
    const state = useContext(GlobalState)
    const [token] = state.token

    const [dataFile, setDataFile] = useState('')
    const [fileName, setFileName] = useState('')
    const [sheetNumber, setSheetnmber] = useState(null)

    const [dataFile1, setDataFile1] = useState('')
    const [fileName1, setFileName1] = useState('')
    const [sheetNumber1, setSheetnmber1] = useState(null)

    const handleFile = (e)=>{
        const file = e.target.files[0];
        if (file) {
            // Chuyển đổi tệp thành BLOB
            const reader = new FileReader();
            reader.onload = (event) => {
                const blob = new Blob([event.target.result], { type: file.type });
                setDataFile(blob);
                setFileName(file.name)
            };
            reader.readAsArrayBuffer(file);
        }
    }

    const handleFile1 = (e)=>{
        const file = e.target.files[0];
        if (file) {
            // Chuyển đổi tệp thành BLOB
            const reader = new FileReader();
            reader.onload = (event) => {
                const blob = new Blob([event.target.result], { type: file.type });
                setDataFile1(blob);
                setFileName1(file.name)
            };
            reader.readAsArrayBuffer(file);
        }
    }

    const handleSubmit = async ()=>{
        if(!dataFile){
            alert('Vui lòng chọn file.')
        }
        else if(!sheetNumber){
            alert('Vui lòng nhập thứ tự sheet.')
        }
        else {
            try {
                const formData = new FormData();
                formData.append('file', dataFile, `${fileName}`);
    
                const res = await axios.post(`/api/infor?sheet=${sheetNumber}`, formData, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'multipart/form-data'
                    }
                })
                alert(res.data.msg)
                
            } catch (err) {
                alert(err.response.data.msg)
            }
        }
    }

    const handleUpdate = async ()=>{
        if(!dataFile1){
            alert('Vui lòng chọn file.')
        }
        else if(!sheetNumber1){
            alert('Vui lòng nhập thứ tự sheet.')
        }
        else {
            try {
                const formData = new FormData();
                formData.append('file', dataFile1, `${fileName1}`);
    
                const res = await axios.put(`/api/infor?sheet=${sheetNumber1}`, formData, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'multipart/form-data'
                    }
                })
                alert(res.data.msg)
                
            } catch (err) {
                alert(err.response.data.msg)
            }
        }
    }

    // console.log(dataFile)

  return (
    <div className='relative'>
        <img src={bg} alt='bg' className='w-full h-screen'/>
        <div className='mt-[150px] flex absolute top-0 left-[50%] translate-x-[-50%]'>
            <div className='text-center mr-[40px] border-[3px] border-[#4ebe29] p-[10px] bg-white'>
                <p className='font-bold mb-[20px] text-[#4ebe29]'>Thêm dữ liệu</p>
                <input type="file" accept=".xlsx, .xls, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" onChange={handleFile} onClick={e => (e.target.value = null)}
                    className='h-[40px] mb-[20px]' />
                <br/>

                <input type="number" value={sheetNumber} onChange={(e)=>setSheetnmber(e.target.value)} placeholder='Nhập thứ tự sheet....'
                    className='w-[300px] h-[40px] border-[1px] border-[#bbb] text-center rounded-sm shadow-md' />
                <br/>
                <button className='bg-[#4ebe29] text-white font-bold px-[15px] py-[5px] rounded-sm mt-[20px] hover:bg-[#5bdb31] shadow-md'
                    onClick={handleSubmit}>Thêm</button>
            </div>

            <div className='text-center ml-[40px] border-[3px] border-[#3399FF] p-[10px] bg-white'>
                <p className='font-bold mb-[20px] text-[#3399FF]'>Cập nhật dữ liệu</p>
                <input type="file" accept=".xlsx, .xls, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" onChange={handleFile1} onClick={e => (e.target.value = null)}
                    className='h-[40px] mb-[20px]' />
                <br/>

                <input type="number" value={sheetNumber1} onChange={(e)=>setSheetnmber1(e.target.value)} placeholder='Nhập thứ tự sheet....'
                    className='w-[300px] h-[40px] border-[1px] border-[#bbb] text-center rounded-sm shadow-md' />
                <br/>
                <button className='bg-[#3399FF] text-white font-bold px-[15px] py-[5px] rounded-sm mt-[20px] hover:bg-[#56a6f6] shadow-md'
                    onClick={handleUpdate}>Cập nhật</button>
            </div>
        </div>
    </div>
    // <div className='flex justify-center'>
    //     <div className='text-center mr-[40px] border-[3px] border-[#4ebe29] mt-[100px] p-[10px]'>
    //         <p className='font-bold mb-[20px] text-[#4ebe29]'>Thêm dữ liệu</p>
    //         <input type="file" accept=".xlsx, .xls, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" onChange={handleFile} onClick={e => (e.target.value = null)}
    //             className='h-[40px] mb-[20px]' />
    //         <br/>

    //         <input type="number" value={sheetNumber} onChange={(e)=>setSheetnmber(e.target.value)} placeholder='Nhập thứ tự sheet....'
    //             className='w-[300px] h-[40px] border-[1px] border-[#bbb] text-center rounded-sm shadow-md' />
    //         <br/>
    //         <button className='bg-[#4ebe29] text-white font-bold px-[15px] py-[5px] rounded-sm mt-[20px] hover:bg-[#5bdb31] shadow-md'
    //             onClick={handleSubmit}>Thêm</button>
    //     </div>

    //     <div className='text-center ml-[40px] border-[3px] border-[#3399FF] mt-[100px] p-[10px]'>
    //         <p className='font-bold mb-[20px] text-[#3399FF]'>Cập nhật dữ liệu</p>
    //         <input type="file" accept=".xlsx, .xls, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" onChange={handleFile1} onClick={e => (e.target.value = null)}
    //             className='h-[40px] mb-[20px]' />
    //         <br/>

    //         <input type="number" value={sheetNumber1} onChange={(e)=>setSheetnmber1(e.target.value)} placeholder='Nhập thứ tự sheet....'
    //             className='w-[300px] h-[40px] border-[1px] border-[#bbb] text-center rounded-sm shadow-md' />
    //         <br/>
    //         <button className='bg-[#3399FF] text-white font-bold px-[15px] py-[5px] rounded-sm mt-[20px] hover:bg-[#56a6f6] shadow-md'
    //             onClick={handleUpdate}>Cập nhật</button>
    //     </div>
    // </div>
  )
}
